import React, { useEffect, useState } from 'react';
import { injectStripe } from "react-stripe-elements";

import request from '../../../common/utils/request';

function Confirmation({ stripe }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [error500, setError500] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    function payAcademyArticles(response) {
      if(!!!response.grow) {
        setLoading(false);
        return;
      }

      let grow = response.grow;

      switch(grow.status) {
        case 'requires_action':
          stripe.confirmCardPayment(grow.client_secret).then((result) => {
            if (result.error) {
              setError(result.error.message);
            }
            setLoading(false);
          });
          break;
        case 'fail':
          setError(grow.error);
          setLoading(false);
          break;
        default: // 'succeeded'
          setLoading(false);
      }
    }

    function handleSuccess(response) {
      switch(response.status) {
        case 'requires_action':
          stripe.confirmCardPayment(response.client_secret).then((result) => {
            if (result.error) {
              setError(result.error.message);
            } else {
              // result.paymentIntent.id
              setMessage('Subscription was paid successfully.');
            }
            payAcademyArticles(response);
          });
          break;
        case 'fail':
          setError(response.error);
          setLoading(false);
          break;
        default: // 'active'
          setMessage(response.message);
          payAcademyArticles(response);
      }
    }

    function handleError(response) {
      setError500(response.message);
      setLoading(false);
    }

    request('post', '/api/subscriptions')
      .then(handleSuccess)
      .catch(handleError);
  }, []);

  return (
    <div className="pro-landing-message">
      <div className="container">
        {loading && !error && !error500 &&
        <div>
          <p>Subscription payment processing.</p>
          <p>Please, wait to continue...</p>
        </div>
        }
        {!loading && !error && !error500 &&
        <div>
          <p>{message}</p>
          <p>Visit our training academy to get started.</p>
          <ul className="pro-hero-buttons_list">
            <li className="pro-hero-buttons_list-item">
              <a className="btn pro-hero-buttons_button" href="/design/academy">Training academy</a>
            </li>
          </ul>
        </div>
        }
        {error &&
        <div>
          <p>Subscription payment crashed for the following reason: {error}</p>
          <p>Try to correct your credit&nbsp;
            <a className="button btn-link" href="/admin/account/billing">
              card details
            </a>
            &nbsp;in your account.
          </p>
          <p>If you have any questions, please send it to admin.</p>
        </div>
        }
        {error500 &&
        <div>
          <p>Subscription payment crashed.</p>
          <p>Please inform the administrator to solve the issue soon.</p>
        </div>
        }
      </div>
    </div>
  );
}

export default injectStripe(Confirmation);



// WEBPACK FOOTER //
// ./app/javascript/components/subscription_confirmation/components/Confirmation.js